import { render, staticRenderFns } from "./SerieDocumental.vue?vue&type=template&id=f81c884c&"
import script from "./SerieDocumental.vue?vue&type=script&lang=js&"
export * from "./SerieDocumental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports